import { Component, OnInit } from '@angular/core';
import { PropertyInterface } from 'app/interface/property';
import { PropertyViewCard } from 'app/models/property-view-card';
import { ApplicationDataService } from 'services/application.service';
import { RenewalCogService } from 'services/renewalcog.service';

@Component({
  selector: 'app-renewal-review-cog',
  templateUrl: './renewal-review-cog.component.html',
  styleUrls: ['./renewal-review-cog.component.css']
})
export class RenewalReviewCogComponent implements OnInit {

  model: PropertyViewCard = new PropertyViewCard()
  baseRent: number = null

  constructor(private applicationService: ApplicationDataService, private renewalService: RenewalCogService) {

    this.applicationService.getProperty(localStorage.getItem('YardiKey')).subscribe(res => this.onGetPropertyResponse(res));
    this.renewalService.getRenewalPropertyBaseRent(Number(localStorage.getItem('RenewalKey'))).subscribe(res => this.onGetRenewalPropertyBaseRent(res));
  }

  ngOnInit() {
  }

  onGetPropertyResponse(prop: PropertyInterface) {
    this.model = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
    this.model.sqft = this.model.sqft.toLocaleString();
    this.model.rent = this.model.rent.toLocaleString();
  }

  onGetRenewalPropertyBaseRent(rentAmount: number) {
    this.baseRent = rentAmount;
  }

}
